module.exports = __webpack_public_path__ + "static/media/3.bbb1b33a.jpg";